import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 32 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0.1, as: Tag = "h1", testId }) => (
  <Tag className={className} data-testid={testId}>
    {lines.map((l, i) => (
      <span key={i} className={`block overflow-hidden pb-[0.08em] ${lineClass}`}>
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.1, delay: delay + i * 0.13, ease: [0.16, 1, 0.3, 1] }}
        >
          {l}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[#D4A359] ${className}`}>
    <span className="h-px w-8 bg-[#D4A359]/60" />
    {children}
  </p>
);
